import { gql } from "@apollo/client";

export const findEarnings = gql`
  query findEarnings($filter: CustomizedEarningFilter) {
    findEarnings(filter: $filter) {
      total
      items {
        id
        name
        startDate
        endDate
        newQuantity
        isActive
        rewardMappings {
          rewardId
          campaignIds
        }
      }
    }
  }
`;
